import { render, staticRenderFns } from "./schools.vue?vue&type=template&id=30f73217&"
import script from "./schools.vue?vue&type=script&lang=js&"
export * from "./schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SchoolCard: require('/opt/buildhome/repo/components/schools/SchoolCard.vue').default,ScrollToTop: require('/opt/buildhome/repo/components/utils/ScrollToTop.vue').default})
